/* eslint-disable object-curly-newline */
G.OMTsettings = {
  /* configuration for Delta DNA, comment out block or remove to disable */
  DDNA: {
    collect: 'https://collect15279ckcrs.deltadna.net/collect/api/',
    engage: 'https://engage15279ckcrs.deltadna.net/',
    env: G.BuildEnvironment.production ? '47962140713416928825554937215584' : '47962133040881921179996109915584',
    queueInterval: 1000,
    ftuxVersion: 1, // this should be a integer
  },

  /* configuration for cross promotions */
  crossPromo: {
    promoId: 'cookie-crush-4',
    showIcon: true,
    worldMapIcon: {
      width: 127,
      height: 127,
    },
  },

  /* configuration for tournaments */
  tournaments: {
    levelLoop: ['tournament_3', 'tournament_2287', 'tournament_2288', 'tournament_2289', 'tournament_2290', 'tournament_2286'],
    rotationOriginTimestamp: 1603065600000, // unix timestamp (1603065600000, is Monday 00:00:00, October 19th, 2020)
    rotationIntervalHrs: 24 * 7, // total hours for level rotation including the cooldown
    cooldownDurationHrs: 24 * 2, // hours at beginging of rotation
    promotionPosOffset: {
      gingy: {
        y: 21,
      },
      tournamentText: {
        y: 0,
      },
    },
  },

  shoutouts: {
    amountTier0: 3,
    amountTier1: 2,
  },

  adFallback_AskFriend: {
    title: {
      style: { style: 'font-white', fontSize: 40 },
      offsetY: 0,
    },
    graphics: {
      evenColourBg: 0xffca93,
      oddColourBg: 0xfee6c4,
    },
  },

  requestHelp: {
    positionals: {
      useTwoPiecePopup: false,
      maskRadius: 25,
      listOffsetX: 0,
      scrollbarOffsetHeight: 0,
    },
  },

  friendshipChest: {
    assets: {
      storyChests: [
        { asset: 'storyFriendshipChest1', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest2', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest3', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest4', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest5', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest6', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest7', background: 'friendshipPolaroidBg' },
      ],
    },
    layoutData: {
      messageHardBackground: 0xffa200,
      cardBackground: 0xFFF1BB,
      chestIsFacingRight: false,
      messageJoined: {
        fontSize: '150px',
        lineSpacing: -20,
        width: 272,
        height: 175,
      },
      bannerMask: {
        x: -301.74,
        y: -9.599999999999994,
        width: 603.48,
        height: 108,
      },
      bannerText: {
        yOffset: -5,
        fontSize: 48,
        offsetDivision: 8,
      },
    },
    maxCards: 50,
    width: 150,
  },

  FTUXSettings: {
    runLevelsUpTo: 10,
    disablePopUpTutorial: 45,
    gingyPosOffset: {
      y: 0,
    },
  },

  mapChest: {
    startLevel: 10,
    reoccuringLevel: 10,
    formulaChangePoint: 100,
    mapTileSizeInLevels: 16,
    appearanceNodes: [
      [ // level 1 ~ 5
        { x: -177, y: -401 },
        { x: 218, y: -459 },
        { x: 81, y: -556 },
        { x: -90, y: -594 },
        { x: 173, y: -760 },
      ],
      [ // 6 ~ 10
        { x: 172, y: -769 },
        { x: -27, y: -856 },
        { x: 57, y: -959 },
        { x: -264, y: -983 },
        { x: 269, y: -1097 },
      ],
      [ // 11 ~ 16
        { x: 31, y: -1270 },
        { x: -245, y: -1270 },
        { x: 195, y: -1278 },
        { x: 66, y: -1370 },
        { x: -216, y: -1447 },
        { x: 226, y: -1469 },
      ],
    ],
  },

  postcardEvent: { // Data for the postcard event
    unlockData: {
      saveKey: 'easter2022',
    },
    title: {
      imageOffset: { x: 0, y: -20 },
    },
    cardData: {
      extraAssets: [
        { asset: 'tokenEventStamp', anchor: 'top_right', offset: { x: -25, y: 20 } },
      ],
    },
  },

  // Config for the special shop deal. Similar to eventPostcard but doesn't come with a lot of extra stuff
  specialShopDeal: {
    firstTimePackId: 'summer2020First',
    regularPackId: 'summer2020',
    valueTagMultiplier: 1,
    valueTagColours: 0xFF0000,
    coinBarTint: 0xc74bf6,
    mapIcon: {
      asset: 'summerSaleMapIcon',
      width: 150,
      height: 150,
    },
    saleBannerText: {
      offsetY: 3,
    },
  },

  tokenEvent: {
    gameBackgroundAsset: 'background_1', // otherwise 'tokenEvent_background'
    levelList: [
      103, 104, 106, 115, 118, 125, 126, 129, 130, 131,
      135, 136, 137, 148, 149, 164, 167, 176, 182, 189,
      191, 193, 194, 199, 205, 206, 209, 222, 230, 232,
      234, 235, 237, 268, 282, 306, 330, 344, 347, 359,
      396, 411, 413, 430, 434, 439, 442, 443, 447, 458,
      463, 478, 482, 495, 497, 502, 503, 517, 539, 553,
      555, 573, 575, 576, 577, 586, 603, 617, 631, 673,
      702, 711, 713, 714, 719, 720, 721, 723, 734, 738,
      744, 748, 753, 760, 768, 770, 778, 806, 811, 817,
      821, 825, 826, 831, 849, 856, 874, 887, 892, 899,
    ],
    mapIcon: {
      offsetY: 50,
      layout: {
        bg: {
          x: 0,
          y: -35,
        },
        timerBanner: {
          x: 0,
          y: 25,
        },
        timerText: {
          x: 12,
          y: 25,
        },
      },
    },
    // configuration for special event leaderboard
    leaderboardConfig: {
      header: {
        scale: 0.825,
        bg: { asset: 'eventPostcardHeader' },
        titleBg: { x: 0, y: -10, asset: 'eventPostcardTitle' },
        title: {
          x: 0, y: 75, baseStyle: 'tokenEvent-eventLevelTitle', fontSize: '65px', maxWidth: 370, maxHeight: 100, text: 'Easter',
        },
        subTitleBg: { x: 0, y: 150, asset: 'leaderboard-subheader-bar' },
        subTitle: {
          x: 0, y: 150, baseStyle: 'font-white', fontSize: '45px', maxWidth: 370, maxHeight: 80, text: 'Leaderboard',
        },
      },
      collectMsg: {
        fieldConfig: {
          topOffset: 845,
        },
      },
      tabs: {
        topOffset: 250,
        dividerStroke: { color: 0xb052de },
      },
      playBtn: {
        topOffset: 920,
      },
      panel: {
        topOffset: 250,
        userView: {
          icon: {
            offsetY: 0,
          },
          scoreField: {
            fontStyle: {
              fill: '#FFFFFF',
            },
          },
          usernameField: {
            fontStylePlayer: {
              fontSize: '50px',
              style: 'font-orange',
              fill: 'white',
            },
          },
        },
      },
    },
    popupOfferLayout: {
      deal: {
        assetsKeys: {
          NON_PAYER_TOKENEVENT: 'tokenEvent_offer_small',
          PAYER_TOKENEVENT: 'tokenEvent_offer_small',
        },
      },
      bg: {
        height: 550,
        outerBgAsset: 'tokenEvent_popup_background',
        outerSlices: null, // background not 9-sliced
        innerOffsetX: -20,
        innerOffsetY: 45,
        innerFrameVisible: false, // we don't have a inner frame for this design
      },
      header: {
        offsetY: 20,
        ribbonOffsetY: 5,
        textOffsetY: 25,
        ribbonConfig: {
          asset: 'tokenEvent_banner',
          sliceRect: null,
          height: 175,
        },
        textConfig: {
          style: { style: 'tokenEvent-eventLevelTitle', lineSpacing: -15, fontSize: '40px' },
          maxWidth: 200,
        },
      },
      multiplier: {
        offsetY: 40,
        offsetX: -40,
        scale: 0.8,
        bgScale: 1.05,
        txt: { offsetX: 0, offsetY: -10, content: 'x5' },
        altBgAsset: 'tokenEvent_shopBadge',
      },
      dealGraphic: {
        offsetX: 5,
      },
      dealCoinbar: {
        tint: 0xff0000,
      },
      playerCoinbar: {
        offsetY: -265,
        scale: 0.8,
      },
      exitConfirm: {
        mascot: { offsetX: -10000 }, // mascot offscreen doesn't fit the layout
        bubble: { offsetX: 0, offsetY: -344 }, // bubble needs to be re-centered with mascot missing
      },
      buyButton: { offsetY: 15 },
      windowHeader: { // config for event window headers. Any window that has text that uses "tokenEvent-eventLevelTitle" style)
        text: {
          x: 0,
          y: -260,
        },
      },
      showTargetOffer: false,
    },
    shopData: {
      shopKey: 'easter',
      firstTimeBuyerKey: 'first',
      background: 'specialdeal_bg',
      chest: 'shop3_specialDeal1',
      coinbar: 'shop3_dealCoinBar',
      specialPopupOffer: 'Summer special offer',
      coinBarTint: 0xc74bf6,
      coinBarTextStyle: 'eventPostcard-shopCoinText',
    },
    windowEventEntry: {
      mascot: {
        scale: {
          horizontal: 1.2,
          vertical: 0.85,
        },
      },
    },
    // config for event window headers
    // (generally, any window that has text that uses "tokenEvent-eventLevelTitle" style)
    windowHeader: {
      text: {
        x: 0,
        y: -275,
      },
    },
    styling: {
      windowTextFill: '#e75656', // colour of text in level flow windows
      taskTextFill: '#e75656', // Colour of the task text on the level window
    },
  },

  treasureHuntSuper: {
    worldMapIcon: {
      offsetY: 10,
    },
    levels: {
      useList: true,
      levelList: [
        103, 104, 106, 115, 118, 125, 126, 129, 130, 131,
        135, 136, 137, 148, 149, 164, 167, 176, 182, 189,
        191, 193, 194, 199, 205, 206, 209, 222, 230, 232,
        234, 235, 237, 268, 282, 306, 330, 344, 347, 359,
        396, 411, 413, 430, 434, 439, 442, 443, 447, 458,
        463, 478, 482, 495, 497, 502, 503, 517, 539, 553,
        555, 573, 575, 576, 577, 586, 603, 617, 631, 673,
        702, 711, 713, 714, 719, 720, 721, 723, 734, 738,
        744, 748, 753, 760, 768, 770, 778, 806, 811, 817,
        821, 825, 826, 831, 849, 856, 874, 887, 892, 899,
      ],
      startingLevel: 395,
    },
  },

  unlimitedLivesMinCap: 1440, // The maximum amount of minutes you can get when you get get unlimited lives

  // ===================================================================
  global: {
    gameName: 'Cookie Crush',
    defaultFont: 'Lobster',
    leaderboardName: 'completedLevels',
    cookieCrush4: true,
    window: {
      title: {
        textStyle: 'globalTitleStyle',
      },
    },
  },

  elements: {
    annuityReminderIcon: {
      width: 100,
      height: 150,
      offsetY: 10,
    },
    windowNineSlice: {
      slice: { // The 9 slice of the popup
        top: 107,
        left: 109,
        right: 129,
        bottom: 86,
      },
      whiteSpace: { // The whitespace in the popup
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      inner: { // The px to the inner look-good dimensions of the popup
        top: 107,
        left: 109,
        right: 129,
        bottom: 86,
      },
    },
    leaderboard: {
      tabLivesSelected: true,
    },
    buttonNineSlice: {
      layers: { // Default layers for buttons at regular size
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_base',
        largeDetail: [],
        highlights: 'buttons/btn_highlight',
      },
      smallSlice: { // Default slice for small buttons
        left: 20,
        right: 20,
        top: 10,
        bottom: 10,
      },
      largeDetail: { // Default slice for large/detailed buttons
        left: 25,
        right: 20,
        top: 18,
        bottom: 21,
      },
    },
    buttonTintColours: { // Button nine-slice colour definitions
      green: 0x27fa00,
      blue: 0x3d9bff,
      red: 0xff0000,
      purple: 0xc73eff,
      orange: { // Provides its own layer
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_orange',
        largeDetail: [],
      },
      gray: 0x888888,
      lightGreen: {
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_lightGreen',
        largeDetail: [],
      },
    },
    chestPositioning: {
      inGame: {
        bottom: { x: 0, y: 0 },
        top: { x: -40, y: 0 },
        glow: { x: 0, y: -20 },
      },
      closed: {
        top: {
          x: 0,
          y: -35,
        },
      },
      opened: {
        bottom: {
          x: 0,
          y: 0,
        },
        top: {
          x: 35,
          y: -65,
        },
        glow: {
          x: 1,
          y: -45,
        },
      },
    },
    chestShuffle: {
      charSizeScale: 1,
    },
    tutorialMsg: {
      fontSize: 45,
      lineSpacing: -17,
    },
    dailyReward: {
      title: {
        x: 0,
        y: -285,
        style: 'DailyRewardTitle',
      },
      comeBackTxt: {
        lineSpacing: -20,
      },
    },
    dailyIcon: {
      width: 150,
      height: 90,
    },
    dailyChallengeIcon: {
      offsetY: 10,
      height: 110,
      width: 150,
    },
    dailyMission: {
      ribbonText: {
        yPos: 45,
      },
    },
    deconstructMsg: {
      tournamentTaunt: {
        aheadFriend: {
          x: -180,
          y: 192,
          angle: 0,
          avatar: {
            scale: 1.6,
            x: -8,
            y: -41,
            angle: 5,
          },
        },
        midFriend: {
          x: 35,
          y: 166,
          angle: 0,
          avatar: {
            scale: 1.35,
            x: -21,
            y: -20,
            angle: -11,
          },
        },
        lastFriend: {
          x: 203,
          y: 192,
          angle: 0,
          avatar: {
            scale: 1.2,
            x: 21,
            y: -51,
            angle: 13,
          },
        },
        text: {
          x: 0,
          y: -240,
          angle: 0,
        },
        trophy: { // Relative to aheadFriend
          x: -181,
          y: -31,
          angle: -10,
        },
        sparkles: [ // Relative to the trophy
          { x: 84, y: -76, angle: 0 },
          { x: -56, y: 25, angle: 0 },
          { x: -112, y: -35, angle: 0 },
          { x: 35, y: 54, angle: 0 },
          { x: -43, y: -61, angle: 0 },
          { x: 89, y: -7, angle: 0 },
        ],
      },
    },
    mockFacebookFriends: {
      friends: [
        { name: 'Gingy', image: 'friendshipGingy' },
        { name: 'Bubbles', image: 'friendshipBubbles' },
        { name: 'Finn', image: 'friendshipFinn' },
        { name: 'Dolly', image: 'friendshipDolly' },
        { name: 'Shelly', image: 'friendshipShelly' },
        { name: 'Spike', image: 'friendshipSpike' },
      ],
    },
    giftUI: {
      sideGingy: {
        txt: {
          lineSpacing: -15,
          fontSize: '42px',
        },
      },
    },
    Window_mysteryGift: {
      titleOffsetY: 0,
    },
    highscoreBeaten: {
      continueBtn: {
        x: 0,
        y: 245,
      },
    },
    checkedIconPast: {
      x: 35,
      y: 15,
    },
    checkedIcon: {
      x: 35,
      y: 15,
    },
    mapGift: {
      timer: {
        y: 55,
      },
    },
    worldMap: {
      mapScale: 0.75,
      bubbleScale: 0.7,
      allowHScrolling: false,
      tiles: [
        'Map_path_tile3',
        'Map_path_tile0',
        'Map_path_tile1',
        'Map_path_tile2',
      ],
      tilePropCenter: {
        vertical: [
          [{ x: -300, y: -25, pool: 'left' }, { x: -300, y: -300, pool: 'leftFiller' }],
          [{ x: 300, y: -45, pool: 'right' }, { x: 350, y: -300, pool: 'rightFiller' }],
          [{ x: -300, y: -25, pool: 'behindRiver|left' }, { x: -305, y: 5, pool: 'aboveRiver' }, { x: -300, y: -300, pool: 'leftFiller' }],
          [{ x: 300, y: -45, pool: 'right' }, { x: 350, y: -300, pool: 'rightFiller' }],
        ],
        horizontal: [
          [{ x: -450, y: -55, pool: 'left' }, { x: -450, y: -300, pool: 'leftFiller' }],
          [{ x: 450, y: -65, pool: 'right' }, { x: 450, y: -300, pool: 'rightFiller' }],
          [{ x: -450, y: -95, pool: 'behindRiver|left' }, { x: -400, y: 5, pool: 'aboveRiver' }, { x: -450, y: -300, pool: 'leftFiller' }],
          [{ x: 450, y: -65, pool: 'right' }],
        ],
      },
      riverTileExtra: {
        index: 2, // The index on the tiles array
        offset: [{ x: 332, y: 58 }, { x: 442, y: 92 }, { x: 502, y: 168 }, { x: 456, y: 274 }],
      },
      levelNodePositions: [ // for each tile, from the bottom
        [{ x: 284, y: 60 }, { x: 390, y: 100 }, { x: 482, y: 156 }, { x: 441, y: 251 }],
        [{ x: 355, y: 33 }, { x: 259, y: 70 }, { x: 223, y: 162 }, { x: 232, y: 269 }],
        [{ x: 322, y: 61 }, { x: 424, y: 104 }, { x: 500, y: 177 }, { x: 456, y: 275 }],
        [{ x: 365, y: 62 }, { x: 263, y: 105 }, { x: 173, y: 168 }, { x: 189, y: 266 }],
      ],
      mailboxPositions: [
        [{ x: 242, y: 261, scale: -1 }],
        [{ x: 407, y: 286, scale: 1 }],
        [{ x: 266, y: 276, scale: -1 }],
        [{ x: 491, y: 305, scale: 1 }],
      ],
      chestShufflePositions: [
        [{ x: 242, y: 270, scale: -1 }],
        [{ x: 450, y: 336, scale: 1 }],
        [{ x: 265, y: 289, scale: -1 }],
        [{ x: 488, y: 345, scale: 1 }],
      ],
      sagaMapChestPositions: [
        [{ x: 241, y: 219, scale: -1 }],
        [{ x: 537, y: 275, scale: 1 }],
        [{ x: 262, y: 232, scale: -1 }],
        [{ x: 487, y: 259, scale: 1 }],
      ],
      rewardPerTile: [
        'mailbox',
        'chestMap',
        'chestShuffle',
        'chestMap',
        '',
      ],
      riverTint: [
        0xb4ffde,
        0xffe2fd,
        0xc2f1ff,
        0xffef91,
        0xebcbff,
      ],
      grassColour: 0x8dd415,
    },
    LossAversionWheelGroup: {
      useVillainTitles: true,
    },
    worldMapButtonOrder: {
      vertical: {
        left: ['tournament', 'dailyChallenge', 'tokenEvent', 'specialshopdeal', 'treasurehunt'],
        right: ['mapGiftannuityreminder', 'dailyIcon', 'friendshipChest', 'xPromo'],
        alignXDynamically: true,
      },
      horizontal: {
        left: ['xPromo'],
        right: ['mapGiftannuityreminder', 'dailyIcon', 'friendshipChest', 'tournament', 'dailyChallenge', 'tokenEvent', 'specialshopdeal', 'treasurehunt'],
        alignXDynamically: true,
      },
    },
    worldMapLvlButton: {
      lvlNrText: {
        style: 'worldMapLvlButtonText',
      },
      closedMsg: {
        style: 'lvlButtonCloseMessage',
        x: 547.5,
        y: 198,
        width: 169,
        height: 142,
      },
    },
    RealMoneyWheel: {
      gingy: {
        x: 0,
        y: 270,
        bobbingAnim: true,
        bobbingAnimConfig: {
          vDisplacement: 10,
          hDisplacement: 0,
          cycleLength: 7500, // ms
        },
      },
    },

    // config overrides for wheels / wheel items
    wheelConfigs: {
      dailyPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 33 }, offset: { y: 4 } },
            icon: { scale: 0.65 },
          },
          COINS_SPECIAL: {
            text: { style: { fontSize: 29 }, offset: { y: 2 } },
            icon: { scale: 0.65 },
          },
          BOOSTER: {
            text: { style: { fontSize: 33 }, offset: { y: 4 } },
          },
        },
      },
      lossAversionPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 40 } },
          },
        },
      },
      requestHelpPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 40 } },
          },
        },
      },
      realMoneyPrizeWheel: {
        itemConfigOverrides: {
          COINS: {
            text: {
              style: 'realMoneyWheel-coinTextGold',
              offset: { x: 125, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 145, y: 0 },
            },
          },

          COINS_SPECIAL: {
            text: {
              style: 'realMoneyWheel-coinTextGoldSpecial',
              offset: { x: 125, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 145, y: 0 },
            },
          },

          COINS_PLAT: {
            text: {
              style: 'realMoneyWheel-coinTextPlat',
              offset: { x: 145, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 165, y: 0 },
            },
          },

          COINS_SPECIAL_PLAT: {
            text: {
              style: 'realMoneyWheel-coinTextSpecialPlat',
              offset: { x: 145, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 165, y: 0 },
            },
          },
        },
      },
    },

    Window_friendOvertaken: {
      titleTxt: {
        style: 'friendOvertaken',
      },
    },
    Window_shop2: {
      isShowing3hGift: true,
      topBarTextOffset: -5,
      useTileEntryBorder: true,
      scrollHeightOffset: 8,
    },
    Window_shop3: {
      overrideTier: 1,
      maxSpecialSlots: 6,
      regularDealFrameSlice: { // Slices for the frame
        top: 37,
        bottom: 121,
        right: 60,
        left: 75,
      },
      headerSlice: { // Nineslice for header pieces
        top: 19,
        left: 8,
        bottom: 19,
        right: 8,
      },
      headerTextOffset: {
        y: -2,
      },
      specialDealFrameExtra: {
        offsetX: 0,
        offsetY: 0,
        topOfFrame: 45,
        bottomOfFrame: 158,
      },
      specialDealFrameSlice: { // The slices for the special deal frames
        top: 45,
        bottom: 158,
        left: 68,
        right: 201,
      },
      specialDealRibbonSize: { // Size of ribbion
        height: 60,
      },
      specialDealRibbonSlice: { // The slices for the ribbon
        top: 30,
        bottom: 30,
        left: 58,
        right: 58,
      },
      specialDealBoosterBoxSlice: { // The slices for the booster box details
        top: 40,
        bottom: 35,
        left: 43,
        right: 49,
      },
      tagBaseMultipler: 0.9,
      regularDealTagIndex: 1,
      specialDealTintData: [ // Tint data on the layout
        {
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox0',
            coinBar: {
              tint: 0x12aaff,
              textStyle: 'shop3-boosterTextStyle0',
            },
          },
          valueTagTint: 1,
        },
        {
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox1',
            coinBar: {
              tint: 0xdb59ff,
              textStyle: 'shop3-boosterTextStyle1',
            },
          },
          valueTagTint: 0,
        },
        {
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox2',
            coinBar: {
              tint: 0xff4cb9,
              textStyle: 'shop3-boosterTextStyle2',
            },
          },
          valueTagTint: 2,
        },
        { // FTU
          boosterBox: {
            asset: 'shop3_specialDealBoosterBoxFTU',
            coinBar: {
              tint: 0xff4200,
              textStyle: 'shop3-boosterTextStyle3',
            },
          },
          valueTagTint: 1,
        },
        { // Weekend deal
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox4',
            coinBar: {
              tint: 0xba0d03,
              textStyle: 'shop3-boosterTextStyle4',
            },
          },
          valueTagTint: 0,
        },
        { // Annuity
          boosterBox: {
            asset: 'shop3_annuityBoosterBox',
            coinBar: {
              tint: 0x9e00f4,
              textStyle: 'font-white',
            },
          },
          valueTagTint: 0,
        },
      ],
      weekendTimerArea: {
        x: 134,
        y: 80,
        width: 101,
        height: 72,
      },
    },
    Window_highscoreBeaten: {
      titleTxt: {
        style: 'highscoreBeaten',
      },
    },
    Window_crossPromo: {
      titleTxt: {
        x: 0,
        y: -240,
      },
      continueBtn: {
        x: 0,
        y: 250,
      },
      continueBtnTxt: {
        x: 0,
        y: 0,
        style: 'XPromoContinue',
      },
    },
    Window_OutOfMovesIAP: {
      elementLayouts: {
        windowHeight: { min: 960, max: 1140 },
        yPos: { // range of y-positions (for responsiveness)
          coinBar: { min: -420, max: -460 },
        },
      },
    },
    Window_giveUp: {
      levelTxt: {
        style: 'giveUpLevelTxt',
      },
    },
    Window_Brag: {
      bgScaleMode: 'scaleToFit',
      closeButton: { offsetX: 0, offsetY: 0 },
      bannerImage: { fullscreen: 'store_bg' },
      content: {
        friendsLayout: { // double avatar layout
          fullscreen: { x: 0, y: -61, minWidth: 200, maxWidth: 540 },
          friendAvatar: {
            avatarSize: 135,
            x: 124,
            y: 5,
            angle: 2,
          },
          playerAvatar: {
            avatarSize: 135,
            x: -156,
            y: 3,
            angle: -5,
          },
        },
        soloLayout: { // single avatar layout
          fullscreen: { x: 25, y: -30, minWidth: 750, maxWidth: 800 },
          playerAvatar: {
            avatarSize: 118,
            x: -65,
            y: 4,
            angle: -4,
          },
        },
        skipTutorialLayout: { // for first time users winning a challenge
          fullscreen: { x: 0, y: 50, minWidth: 0, maxWidth: 650 },
          imageScale: 0.65,
          playerAvatar: {
            avatarSize: 100,
            x: -100,
            y: -50,
            angle: 0,
          },
        },
      },
    },
    Window_botOptIn: {
      titleTxt: {
        style: 'BotOptInTitle',
      },
    },
    Window_notEnoughLives: {
      livesNrTxt: {
        x: 0,
        y: -60,
      },
      coinsTxt: {
        x: 10,
        y: -279,
        style: 'NotEnoughLivesCoins',
      },
      buyLifeButton_coinTxt: {
        style: 'NotEnoughLivesBuyCoin',
      },
    },
    Window_tournament: {
      taskTxt: {
        y: -47,
      },
      scoreBg: {
        y: -115,
      },
      scoreTxt: {
        y: -178,
      },
      highScoreField: {
        y: -112,
      },
    },
    Window_taskSlider: {
      taskTxt: {
        y: 48,
        style: {
          style: 'taskText',
        },
      },
      goal: {
        style: {
          style: 'taskGoal',
        },
      },
    },
    Window_newsHomeScreen: {
      button: {
        shouldPulse: true,
        x: 0,
        y: 215,
      },
      continueBtn: {
        x: 0,
        y: 295,
      },
      continueBtnTxt: {
        x: 0,
        y: 295,
      },
    },
    Window_timedTargetedOffer: {
      vertical: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetX: 0,
          offsetY: -435,
          scale: 0.95,
        },
        dealCoinbar: {
          textOffsetY: 0,
        },
        multiplier: {
          offsetY: 15,
          offsetX: -22,
          scale: 0.95,
          bgScale: 1.05,
          txt: { offsetX: 1, offsetY: 1 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetY: -12,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: 100,
          ribbonOffsetY: 5,
          timerOffsetY: -21,
          textOffsetY: 20,
        },
        exitConfirm: {
          mascot: { offsetX: -175, offsetY: 0, scale: 0.8, character: 'graham' },
          bubble: { offsetX: 320, offsetY: -100 },
        },
        buyButton: { offsetY: 280 },
        boosterIcon: { labelPaddingY: -15 },
        unlimitedLivesIcon: { labelPaddingY: 5 },
      },
      horizontal: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetX: -345,
          offsetY: -220,
          scale: 1,
        },
        dealCoinbar: {
          textOffsetY: 0,
        },
        multiplier: {
          offsetY: 12,
          offsetX: -812,
          scale: 1,
          bgScale: 1.1,
          txt: { offsetX: 0, offsetY: 0 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetX: -240,
          innerOffsetY: 23,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: 100,
          ribbonOffsetY: 5,
          timerOffsetY: -21,
          textOffsetY: 20,
        },
        exitConfirm: {
          mascot: { offsetX: -425, offsetY: 0, scale: 1, character: 'graham' },
          bubble: { offsetX: 0, offsetY: -300 },
        },
        buyButton: { offsetY: 350 },
        boosterIcon: { labelPaddingY: -15 },
        unlimitedLivesIcon: { labelPaddingY: 5 },
      },
    },

    Window_oneTimeTargetedOffer: {
      vertical: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetY: -240,
        },
        dealCoinbar: {
          scale: 1.2,
          fontSize: 36,
          tint: 0xFF4210,
        },
        multiplier: {
          offsetY: 15,
          offsetX: -22,
          scale: 0.95,
          bgScale: 1.05,
          txt: { offsetX: 1, offsetY: 1 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetY: -12,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: -2,
          ribbonOffsetY: 5,
          textOffsetY: 2,
        },
        exitConfirm: {
          mascot: { offsetX: 45, offsetY: 62 },
          bubble: { offsetX: 25, offsetY: -335 },
        },
        buyButton: { offsetY: -2 },
      },
      horizontal: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetY: -260,
        },
        dealCoinbar: {
          scale: 1.2,
          fontSize: 36,
          tint: 0xFF4210,
        },
        multiplier: {
          offsetY: 12,
          offsetX: -812,
          scale: 1,
          bgScale: 1.1,
          txt: { offsetX: 0, offsetY: 0 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetX: -240,
          innerOffsetY: 23,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: -2,
          ribbonOffsetY: 5,
          textOffsetY: 2,
        },
        exitConfirm: {
          mascot: { offsetX: 1045, offsetY: 5, scaleX: -0.6, scaleY: 0.6 },
          bubble: { offsetX: 563, offsetY: -180 },
        },
        buyButton: { offsetY: -1 },
      },
    },

    Window_noAdsPopup: {
      vertical: {
        window: {
          x: 0,
          y: 0,
        },
        title: {
          x: 0,
          y: -284,
          text: 'Did you know?',
          style: 'noAdsPopup-title',
          maxWidth: 340,
        },
        background: {
          width: 560,
          height: 650,
        },
        dealChest: {
          x: 110,
          y: 170,
          scale: 0.9,
        },
        gingy: {
          x: -130,
          y: 182,
          scale: 0.8,
        },
        adCrossed: {
          x: 0,
          y: -5,
          scale: 0.475,
        },
        message: {
          x: 0,
          y: -230,
          maxWidth: 448,
          maxHeight: 165,
          text: 'You can remove forced ads forever by making any purchase in the coins store',
          style: {
            style: 'noAdsPopup-message',
            fontSize: 36,
          },
        },
        continueButton: {
          x: 0,
          y: 320,
          width: 230,
          height: 90,
          text: 'Continue',
          style: {
            style: 'font-white',
            fontSize: 64,
          },
          pulse: 1.05,
        },
      },

      horizontal: {
        window: {
          x: 0,
          y: 100,
        },
        title: {
          x: 0,
          y: -355,
          text: 'Did you know?',
          style: 'noAdsPopup-title',
          maxWidth: 500,
        },
        background: {
          width: 1300,
          height: 800,
        },
        dealChest: {
          x: 380,
          y: 160,
          scale: 1.55,
        },
        gingy: {
          x: -390,
          y: 171,
          scale: 1.4,
        },
        adCrossed: {
          x: 0,
          y: 25,
          scale: 0.95,
        },
        message: {
          x: 0,
          y: -290,
          maxWidth: 1000,
          maxHeight: 200,
          text: 'You can remove forced ads forever by making any purchase in the coins store',
          style: {
            style: 'noAdsPopup-message',
            fontSize: 64,
          },
        },
        continueButton: {
          x: 0,
          y: 300,
          width: 275,
          height: 130,
          text: 'Continue',
          style: {
            style: 'font-white',
            fontSize: 72,
          },
          pulse: 1.05,
        },
      },
    },

    UI_BoosterButton: {
      amount: {
        style: 'UIBoosterAmount',
      },
    },
    UI_StartBoosterButton: {
      amountTxt: {
        style: 'UIStartBoosterAmount',
      },
    },
    taskCollectPanels: {
      amount: {
        style: {
          style: 'font-blue',
        },
      },
    },
    UI_GoalPanelCollect: {
      panelNr: {
        style: 'UIGoalPanelNr',
      },
    },
    UI_GoalPanelPoints: {
      labelTxt: {
        style: 'UIGoalPanelPointsLabel',
      },
      pointsCounter: {
        style: 'UIGoalPanelPointAmount',
      },
    },
    UI_ProgressBarHorizontal: {
      scale: 0.975,
      offset: {
        x: -2,
        y: -5,
      },
    },
    gifts: {
      shineEnabled: false,
    },
    // these colors use { GIFT_COLORS } from "../../js/Elements/Windows/GiftUI/GiftGraphic"
    dailyRewardCalendar: {

      doubleable: true,
      days: [
        {
          gifts: [['coin', 200]],
          boxIcon: [],
        },

        {
          gifts: [['booster#2', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Red',
              ribbonTint: 'Light_Blue',
              pos: [0, 0],
            },
          ],
        },

        {
          gifts: [['booster#7', 1]],
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Light_Blue',
              ribbonTint: 'Pink',
              pos: [15, 0],
              scale: [0.8, 0.8],
            },
            {
              giftType: 1,
              boxTint: 'Teal',
              ribbonTint: 'Red',
              pos: [-20, 15],
              scale: [0.8, 0.8],
            },
          ],
        },

        {
          gifts: [['booster#5', 1]], // #5/#6 fixed in dailyRewardMgr
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Red',
              pos: [-15, -10],
              scale: [0.8, 0.8],
            },
            {
              giftType: 2,
              boxTint: 'Light_Blue',
              ribbonTint: 'Pink',
              pos: [20, 5],
              scale: [0.65, 0.65],
            },
            {
              giftType: 1,
              boxTint: 'Red',
              ribbonTint: 'Light_Blue',
              pos: [-10, 20],
              scale: [0.7, 0.7],
            },
          ],
        },

        {
          gifts: [['booster#1', 1]],
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Teal',
              pos: [0, -20],
              scale: [0.6, 0.6],
            },
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Light_Blue',
              pos: [-27, 0],
              scale: [0.65, 0.65],
            },
            {
              giftType: 2,
              boxTint: 'Light_Blue',
              ribbonTint: 'Red',
              pos: [15, 15],
              scale: [0.7, 0.7],
            },
          ],
        },

        {
          gifts: [['booster#8', 1]],
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Teal',
              pos: [15, -15],
              scale: [0.75, 0.75],
            },
            {
              giftType: 1,
              boxTint: 'Red',
              ribbonTint: 'Light_Blue',
              pos: [-32, 0],
              scale: [0.6, 0.6],
            },
            {
              giftType: 2,
              boxTint: 'Green',
              ribbonTint: 'Yellow',
              pos: [-5, 10],
              scale: [0.6, 0.6],
            },
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Light_Blue',
              pos: [25, 20],
              scale: [0.5, 0.5],
            },
          ],
        },

        {
          gifts: [
            ['booster#5', 1], // #5/#6 fixed in dailyRewardMgr
            ['booster#8', 1],
          ],
          boxIcon: [
            // leftmost
            {
              giftType: 2,
              boxTint: 'Green',
              ribbonTint: 'Purple',
              pos: [-90, -20],
              scale: [0.6, 0.6],
            },
            // rightmost
            {
              giftType: 2,
              boxTint: 'Light_Blue',
              ribbonTint: 'Red',
              pos: [90, -20],
              scale: [0.6, 0.6],
            },
            // second from right
            {
              giftType: 1,
              ribbonTint: 'Purple',
              boxTint: 'Red',
              pos: [55, -10],
              scale: [0.8, 0.8],
            },
            // second frm left
            {
              giftType: 1,
              boxTint: 'Red',
              ribbonTint: 'Light_Blue',
              pos: [-55, -10],
              scale: [0.8, 0.8],
            },
            // center
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Pink',
              pos: [0, 0],
              scale: [1, 1],
            },

          ],
        },
      ],
    },
    // Super hard update element config
    superhard: {
      sagaMapTutorial: {
        gingyOffset: 0.61,
      },
      window_level: {
        hard_popup: {
          top: 172,
          bottom: 74,
          left: 276,
          right: 259,
        },
        super_hard_popup: {
          top: 149,
          bottom: 90,
          left: 275,
          right: 259,
        },
        hard_tint: 0xEBB5FF,
        super_hard_tint: 0xFFBEBF,
      },
      speech_bubble: {
        hard_bubble: {
          top: 127,
          bottom: 133,
          left: 145,
          right: 145,
        },
        super_hard_bubble: {
          top: 127,
          bottom: 133,
          left: 145,
          right: 145,
        },
        gingy_bubble: {
          top: 0,
          bottom: 0,
          left: 174,
          right: 105,
        },
      },
      villain_speech: {
        hard_win: 'Your sweetness hurts my teeth. This isn\'t over!',
        super_hard_win: 'We may have lost this time, but we\'ll be back! ',
        hard_oom: 'You look bitter! Is that all you have?',
        super_hard_oom: 'This is a waste of our precious time!',
        hard_lose: 'It makes sense to lose to a gentlemen like me!',
        super_hard_lose: 'Look at you, we expected a bit more than that!',
        hard_mystery_gift: 'Good try, chap, but you\'ll have to do better!',
        super_hard_mystery_gift: 'Giving up now will leave a bad taste!',
      },
      bubbleTipPos: {
        hard: {
          'top-right': {
            x: 300,
            y: -17,
          },
          'top-left': {
            x: 250,
            y: -17,
          },
        },
        superhard: {
          'top-right': {
            x: 300,
            y: -17,
          },
          'top-left': {
            x: 250,
            y: -17,
          },
        },
      },
      tutorialSpeech: {
        hard: {
          pre_win_saga_map: [
            {
              source: 'gingy',
              text: "Watch out! It's %mainVillain%!",
              x: 50,
              y: 80,
              clickable: true,
            },
            {
              source: 'villain',
              index: 1,
              subIndex: 1,
              text: 'I will make all cookies in the world sour!',
              x: 50,
              y: 20,
              pos: 'top-left',
            },
          ],
          level_window: [
            {
              source: 'villain',
              index: 1,
              subIndex: 4,
              text: 'I\'ll make your face pucker with sourness!',
              x: 50,
              y: 20,
              pos: 'left',
              duration: 2000,
            },
            {
              source: 'gingy',
              text: 'You can use additional boosters on hard levels!',
              x: 50,
              y: 80,
            },
          ],
          game: [
            {
              source: 'gingy',
              text: 'Oh no! %mainVillain% soured this level!',
              x: 50,
              y: 80,
              clickable: true,
            },
            {
              source: 'gingy',
              text: "Don't forget to use your boosters to end his evil plans!",
              x: 50,
              y: 80,
              offset: {
                y: -40,
              },
              duration: 2500,
            },
            {
              source: 'gingy',
              text: 'Good luck!',
              x: 50,
              y: 80,
            },
          ],
          post_win_saga_map: [
            {
              source: 'gingy',
              text: "Good job, you defeated %mainVillain%! But something tells me he won't give up...",
              x: 50,
              y: 80,
            },
          ],
          post_corruption_level_window: [
            {
              source: 'villain',
              index: 1,
              subIndex: 4,
              text: "I will turn your cookies sour!|Your cookies don't stand a chance here!|You'll see sour is the best flavor of all!",
              x: 50,
              y: 20,
              pos: 'left',
            },
          ],
        },
        super_hard: {
          pre_win_saga_map: [
            {
              source: 'gingy',
              text: "It's %mainVillain% and his partner in citrus crime!",
              x: 50,
              y: 80,
              clickable: true,
            },
            {
              source: 'villain',
              index: 1,
              subIndex: 1,
              text: 'Hello again! Have you met my friend %sideVillain%?',
              x: 50,
              y: 20,
              pos: 'top-left',
              clickable: true,
            },
            {
              source: 'villain',
              index: 2,
              subIndex: 4,
              text: 'They say limes are more sour than lemons.',
              x: 50,
              y: 20,
              pos: 'top-left',
            },
          ],
          level_window: [
            {
              source: 'villain',
              index: 2,
              subIndex: 4,
              text: 'This level will be our most sour yet!',
              x: 50,
              y: 20,
              pos: 'right',
              duration: 3000,
            },
            {
              source: 'gingy',
              text: 'Using extra boosters will help us defeat them!',
              x: 50,
              y: 80,
            },
          ],
          game: [
            {
              source: 'gingy',
              text: "Oh no! %mainVillain% and %sideVillain% really messed up this level! It's looking sour!",
              x: 50,
              y: 80,
              clickable: true,
            },
            {
              source: 'gingy',
              text: "Don't forget to use your boosters to end their evil plans!",
              x: 50,
              y: 80,
              offset: {
                y: -40,
              },
              duration: 2500,
            },
            {
              source: 'gingy',
              text: 'Good luck!',
              x: 50,
              y: 80,
            },
          ],
          post_win_saga_map: [
            {
              source: 'gingy',
              text: 'Good job, you defeated %mainVillain% and %sideVillain%! We are safe for now!',
              x: 50,
              y: 80,
            },
          ],
          post_corruption_level_window: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [4, 4],
              text: 'You think you stand to beat us?|We fancy a good challenge, have at us!|We will be done with you in a jiffy!',
              x: 50,
              y: 20,
              pos: 'double',
            },
          ],
        },
      },
    },
  },
};
